import EFaxList from "components/features/efax/EFaxList";
import React from "react";

const EFaxPage: React.FC = () => {
  return <EFaxList />;
};

export default EFaxPage;
